import React, {useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';

import uniqueId from 'lodash.uniqueid';
import {parseErrorMessages} from 'src/contexts/message-context/message-context-provider';

import BoxLoading from '@pb/kit-component-box-loading';
import {Group} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';
import Loading from '@pb/kit-component-loading';
import {Status, usePushNotification} from '@pb/kit-component-push-notification';

import {TabContent} from '../../../components/tab-content';


import {useError} from './hooks';
import {getSetupBusy, setupDataSelector} from './services/selectors';
import {APIKeySection} from './views/api-key-section';
import {ExcludeAccount} from './views/exclude-account';
import {IPRangesSection} from './views/ip-ranges-section';
import {apiV2Setup} from './views/setup.view.module.styl';


export const SetupController = () => {
    const data = useSelector(setupDataSelector);
    const setupBusy = useSelector(getSetupBusy);
    const {error, setError} = useError();
    const {onCreateNote, onCloseNote} = usePushNotification();
    const errorNoteIdRef = useRef<string | null>(null);

    useEffect(() => {
        if (!error) {
            if (errorNoteIdRef.current) {
                onCloseNote(errorNoteIdRef.current);
                errorNoteIdRef.current = null;
            }
            return;
        }

        if (errorNoteIdRef.current) {
            onCloseNote(errorNoteIdRef.current);
        }

        const noteId = uniqueId('admin-account-api-setup-error-');
        errorNoteIdRef.current = noteId;
        onCreateNote({
            id: noteId,
            status: Status.ERROR,
            buttonProps: {
                iconProps: {type: Icons.CLOSE},
                onClick: () => {
                    setError();
                },
            },
            body: () => parseErrorMessages(error?.message || ''),
        });

        return () => {
            if (errorNoteIdRef.current) {
                onCloseNote(errorNoteIdRef.current);
                errorNoteIdRef.current = null;
            }
        };
    }, [error, onCreateNote, onCloseNote, setError]);

    return data ? (
        <>
            <BoxLoading {...{loading: setupBusy || false}}>
                <TabContent>
                    <Group className={apiV2Setup} direction="v" gap="xxl">
                        <APIKeySection/>
                        <IPRangesSection/>
                        <ExcludeAccount/>
                    </Group>
                </TabContent>
            </BoxLoading>
        </>
    ) : <Loading/>;
};
